//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "BaseLoader",
  props: {
    size: {
      type: String,
      default: "large",
    },
  },
};
